<template>
    <div id="userList">
        <div class="searchContent">
            <div class="p_select" >
                <div class="search_label">查询日期</div>
                <el-date-picker
                        v-model="startTimeTestList"
                        type="date"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        placeholder="选择开始日期">
                </el-date-picker>
            </div>
            <div class="p_select" >
                <el-date-picker
                        v-model="endTimeTestList"
                        type="date"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        placeholder="选择结束日期">
                </el-date-picker>
            </div>
            <div class="p_select" style="float: right;">
                <el-button class="search_btn" @click="getDossierPositionDetail" icon="el-icon-search">查询</el-button>
                <el-button class="add_btn" @click="exportDossierPositionDetailData" icon="el-icon-download" >导出</el-button>
            </div>
        </div>
        <div class="table">
            <el-table id="dossierPositionDetail" :data="dossierPositionDetailData" style="width: 100%" :height=winHeightDetail :header-cell-style="tableHeaderColor">
                <el-table-column prop="dossierId" label="档案ID" align="left"></el-table-column>
                <el-table-column prop="carNumber" label="车牌" align="left"></el-table-column>
                <el-table-column prop="checkDay" label="检测时间" align="left" sortable></el-table-column>
                <el-table-column prop="mile" label="里程" align="left" sortable></el-table-column>
                <el-table-column prop="saName" label="SA" align="left"></el-table-column>
                <el-table-column prop="positionName" label="部位" align="left"></el-table-column>
                <el-table-column prop="durability" label="磨损度" align="left"></el-table-column>

                <el-table-column align="left" label="检测结果">
                    <template slot-scope="scope">
                        <span v-if="scope.row.positionCheckTag == !0">{{scope.row.positionCheckTag}}</span>
                        <span v-else >{{scope.row.tag}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="userName" label="检测技师" align="left"></el-table-column>

                <el-table-column prop="diagnosis" label="描述" align="left"></el-table-column>
                <el-table-column align="left" label="结果">
                    <template slot-scope="scope">
                        <span v-if="scope.row.usFeedback == 0">未登记</span>
                        <span v-if="scope.row.usFeedback == 800" style="color: #13ce66">更换</span>
                        <span v-if="scope.row.usFeedback == 400" style="color: #E6A23C">不更换</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="原因" prop="reasonLabel"></el-table-column>

            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                    @size-change="handleSizeChangeTestList"
                    @current-change="handleCurrentChangeTestList"
                    background
                    :current-page="pageNoTestList"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="pageSizeTestList"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalTestList"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  export default {
    name: "salesDealSummany",
    data(){
      return {
        // 检测清单
        startTimeTestList:'',
        endTimeTestList:'',
        dossierPositionDetailData:[],
        totalTestList:0,
        pageNoTestList:1,
        pageSizeTestList:10,
        winHeightDetail:'200'
      }
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      if(signInfo.orgId > 0){
        this.orgId = signInfo.orgId
      }

      let obj = new Date();
      let month = obj.getMonth() + 1;
      if (month < 10) month = "0" + month;
      this.queryMonth = obj.getFullYear() + "" + month;

      this.queryStartTime = new Date(obj.getFullYear() + "-" + month + "-01").getTime();
      this.startTimeTestList = obj.getFullYear() + "-" + month + "-01";
      this.queryStartTimeUnSold = new Date(obj.getFullYear() + "-" + month + "-01").getTime();


      let after = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)//后一天
      let afterMonth = after.getMonth() + 1;
      if (afterMonth < 10) afterMonth = "0" + afterMonth;
      let afterDay = after.getDate()

      this.queryEndTime = new Date(after.getFullYear() + "-" + afterMonth + "-" + afterDay).getTime();
      this.endTimeTestList = after.getFullYear() + "-" + afterMonth + "-" + afterDay;
      this.queryEndTimeUnSold = new Date(after.getFullYear() + "-" + afterMonth + "-" + afterDay).getTime();


    },
    methods: {
      // 表头样式
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      cellStyle({ row, column, rowIndex, columnIndex }) {
        if(row.columnIndex == 0){
          return 'color: #0D0E12;font-weight: 500;font-size: 14px;'
        }else{
          return 'color: #0D0E12;font-weight: 400;'
        }
      },
      // 合并列
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 2 ) {
          if (rowIndex  === 0) {
            this.$nextTick(() => {
              this.$refs['table_3'].doLayout();
            })
            return {
              rowspan: this.countSoldDetailData.length,
              colspan: 1
            };
          }else {
            return [0, 0]
          }
        }
      },
      //合计栏列
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index === 1 || index === 2) {
            sums[index] = '-';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = '-';
          }
        });
        return sums;
      },
      // 检测清单
      getDossierPositionDetail(){
        const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度

        if (this.startTimeTestList === ""|| this.startTimeTestList === null || this.endTimeTestList === ""|| this.endTimeTestList === null) {
          this.$message({
            message: "请选择日期区间",
            type: 'warning',
            duration:2000,
            offset:windiwHight/2
          });
          return;
        }
        const params = {
          start: this.startTimeTestList,
          end: this.endTimeTestList,
          pageNo: this.pageNoTestList,
          pageSize: this.pageSizeTestList,
        }
        net.request('admin/manage/report/queryDossierPositionDetail', 'post',params).then(res => {
          if(res.code == 0){
            this.dossierPositionDetailData = res.data.rows
            this.totalTestList = res.data.total
            this.winHeightDetail = windiwHight  - 310;
            this.$message({
              message: '查询成功',
              type: 'success',
              duration:2000,
              offset:windiwHight/2
            });
          }else {
            // net.message(this, res.msg, "warning");
            this.$message({
              message: res.msg,
              type: 'warning',
              duration:2000,
              offset:windiwHight/2
            });
          }
        })

      },
      // 导出检测清单
      exportDossierPositionDetailData(){
        if (this.startTimeTestList === ""|| this.startTimeTestList === null || this.endTimeTestList === ""|| this.endTimeTestList === null) {
          net.message(this, "请选择日期区间", "warning");
          return;
        }
        const params = {
          start: this.startTimeTestList,
          end: this.endTimeTestList,
        }
        net.request('admin/manage/report/downloadDossierPositionDetail', 'post',params).then(res => {
          if(res.code == 0){
            this.dossierPositionDetailData = res.data
            setTimeout(() => {
              var wb = XLSX.utils.table_to_book(document.querySelector('#dossierPositionDetail'));
              var wbout = XLSX.write(wb, {
                bookType: "xlsx",
                bookSST: true,
                type: "array"
              });
              try {
                FileSaver.saveAs(
                  new Blob([wbout], { type: "application/octet-stream" }),
                  "检测清单.xlsx"
                );
              } catch (e) {
                if (typeof console !== "undefined") console.log(e, wbout);
              }
              this.getDossierPositionDetail()
            }, 2000);
          }else {
            net.message(this, res.msg, "warning");
            this.getDossierPositionDetail()
          }
        })
      },
      handleSizeChangeTestList(val){
        this.pageSizeTestList = val;
        this.getDossierPositionDetail()
      },
      handleCurrentChangeTestList(val){
        this.pageNoTestList = val;
        this.getDossierPositionDetail(val)
      },
    },
    mounted() {
      //监听键盘Esc按键事件
      let self = this;
      this.$nextTick(function() {
        document.addEventListener('keydown', function(e) {
          //此处填写你的业务逻辑即可
          if (e.keyCode == 27) {
            e.stopImmediatePropagation();
            self.$router.replace({ name: 'OperationDataStatistics' })
          }
        });
      });
    }
  };
</script>

<style lang="less" scoped>
    #userList {
        display: flex;
        flex-direction: column;
        margin: 24px 0 0 24px;
        background: #fff;
        padding-left: 24px;
        /*padding-bottom: 24px;*/

        .searchContent {
            height: 40px;
            background: #fff;
            /*margin: 24px 0 0px 0;*/
            /*display: flex;*/
            /*flex-direction: row;*/
            /*padding-left: 24px;*/
            padding-top: 9px;
            margin-bottom: 24px;
            /*display: flex;*/
            .p_select {
                display: flex;
                padding: 0 24px 0px 0;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .search_btn {
                /*width: 76px;*/
                height: 36px;
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
            .add_btn {
                /*width: 76px;*/
                height: 36px;
                background: rgba(148, 170, 204, 0.08);
                border: 1px solid #2B54FC;
                border-radius: 4px;
                font-size: 14px;
                color: #2B54FC;
            }

            .option_box{
                margin-bottom: 24px;
                display: flex;
                .option_item {
                    width: 200px;
                    height: 36px;
                    margin-right: 12px;
                    background: #FFFFFF;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-weight: 400;
                    font-size: 14px;
                    text-align: center;
                    color: #364556;
                }
                .option_active {
                    background: #2B54FC;
                    color: #FFFFFF;
                    font-weight: 500;
                }
            }
            .option_item_box{
                margin-bottom: 24px;
                display: flex;
                .item_ {
                    height: 36px;
                    margin-right: 12px;
                    background: #FFFFFF;
                    box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                    border-radius: 4px;

                    line-height: 36px;
                    padding: 0 24px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #364556;
                }
                .item_active {
                    background: #2B54FC;
                    color: #FFFFFF;
                    font-weight: 500;
                }
            }

        }
        .list_content {
            background: #fff;
            padding-left: 24px;
            padding-right: 24px;
        }

        .pagination {
            position: relative;
            margin-top: 0;
            background: #fff;
            padding-top: 24px;
            padding-bottom: 10px;
            .el-pagination {
                position: absolute;
                right: 24px;
                .el-pager li:not(.disabled) {
                    .active {
                        background: #009688 !important;
                    }
                }
            }
        }
    }
</style>
<style lang="less">
    td.cellStyle {
        /*position: relative;*/
        .cell {
            position: fixed;
            top: 60%;
            margin-left: 50px;
            /*left: 600px;*/
        }
    }
    .el-table__footer {
        td.cellStyle{

            div {
                display: none;
            }
        }
    }

</style>